import { gql } from "@/__generated__/gql";

export const REPORT_USER_MUTATION = gql(`
mutation ReportUser(
    $reportedUserId: ID!
    $reason: ReportedContentReasonEnum!
    $image: Upload!
  ) {
    createReportedContentMutation(input: {
      input: {
        studentProfile: {
          reportedUserId: $reportedUserId
          reason: $reason
          image: $image
        }
      }
    }) {
      clientMutationId
      errors {
        title
        message
      }
    }
  }
  `);
